import { postRequest } from './request'; // 确保路径正确

// 创建 getConfig 接口
export const addInfo = async (data) => {
  return await postRequest('/person/add', data);
};

// 新增
export const addScene = async (data) => {
  return await postRequest('/person/create', data);
};


// 查询座位
export const getByMobile = async (data) => {
  return await postRequest('/person/getByMobile', data);
};

// 签到
export const signIn = async (data) => {
  return await postRequest('/person/checkByMobile', data);
};
